import { useLanguage } from "../hooks/useLanguage";

const LABELS = {
  en: "🌐 English",
  fr: "🌐 Français",
  es: "🌐 Español",
  sw: "🌐 Kiswahili"
};

const LanguageSwitcher = ({ userId, role }) => {
  const { currentLang, changeLanguage, SUPPORTED } = useLanguage();

  return (
    <select
      style={select}
      value={currentLang}
      onChange={(e) => changeLanguage(e.target.value, userId, role)}
    >
      {SUPPORTED.map((lang) => (
        <option key={lang} value={lang} style={{ background: "#0E5580", color: "#fff" }}>
          {LABELS[lang]}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;

const select = {
  marginLeft: "16px",
  padding: "6px 10px",
  borderRadius: "8px",
  border: "1px solid rgba(255,255,255,0.4)",
  background: "#0E5580",
  color: "#fff",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer",
  outline: "none"
};
